/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_ShortformInputs */

const en_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Shortform`)
};

const fr_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour l'abréviation`)
};

const de_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzform aktualisieren`)
};

const it_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna Shortform`)
};

const ru_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить краткую форму`)
};

const es_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar formato corto`)
};

const zh_cn2_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新简表`)
};

const ja_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートフォームを更新`)
};

const hi_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संक्षिप्त रूप को अपडेट करें`)
};

const pt_pt2_update_shortform = /** @type {(inputs: Update_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar formulário abreviado`)
};

/**
* | output |
* | --- |
* | "Update Shortform" |
*
* @param {Update_ShortformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_shortform = /** @type {((inputs?: Update_ShortformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_ShortformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_shortform(inputs)
	if (locale === "de") return de_update_shortform(inputs)
	if (locale === "it") return it_update_shortform(inputs)
	if (locale === "ru") return ru_update_shortform(inputs)
	if (locale === "es") return es_update_shortform(inputs)
	if (locale === "zh-CN") return zh_cn2_update_shortform(inputs)
	if (locale === "ja") return ja_update_shortform(inputs)
	if (locale === "hi") return hi_update_shortform(inputs)
	if (locale === "pt-PT") return pt_pt2_update_shortform(inputs)
	return en_update_shortform(inputs)
});